module.exports = __webpack_public_path__ + "static/media/cayman-islands.c10ca3bf.png";